import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ModernNavbar from "../components/modern-navbar";
import ModernFooter from "../components/modern-footer";

const KodiAfrica = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="modern-landing">
      <ModernNavbar />

      {/* Hero Section */}
      <section className="hero-modern product-hero kodi-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1 className="hero-title">
                Automated Fiscal
                <span className="gradient-text"> Compliance</span>
              </h1>
              <p className="hero-subtitle">
                Streamline your tax compliance with automated fiscal documents
                processing for Kenya and Tanzania revenue authorities.
              </p>
              <div className="hero-actions">
                <Link to="/login" className="btn-primary">
                  Get Started
                </Link>
              </div>
            </div>
            <div className="hero-visual">
              <div className="dashboard-preview">
                <img
                  src="/assets/dashboard.png"
                  alt="Kodi Africa Dashboard"
                  className="hero-image"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="container">
          <h2 className="section-title">Comprehensive Fiscal Solutions</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📄</div>
              <h3>Invoice Processing</h3>
              <p>
                Automatically process and validate invoices according to local
                tax regulations
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🧾</div>
              <h3>Receipt Management</h3>
              <p>
                Generate and manage compliant receipts for all your business
                transactions
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏛️</div>
              <h3>KRA Integration</h3>
              <p>
                Direct integration with Kenya Revenue Authority for seamless
                compliance
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🇹🇿</div>
              <h3>TRA Integration</h3>
              <p>Full integration with Tanzania Revenue Authority systems</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Real-time Sync</h3>
              <p>Instant synchronization with revenue authority servers</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📊</div>
              <h3>Compliance Reports</h3>
              <p>Generate detailed compliance reports and audit trails</p>
            </div>
          </div>
        </div>
      </section>

      {/* Integration Section */}
      <section className="integration-section">
        <div className="container">
          <div className="integration-content">
            <h2>Trusted Integrations</h2>
            <p>
              We have established integrations with major revenue authorities
              across East Africa
            </p>
            <div className="integration-grid">
              <div className="integration-card">
                <div className="integration-flag">🇰🇪</div>
                <h3>Kenya Revenue Authority</h3>
                <p>Full ETIMS compliance and real-time data submission</p>
              </div>
              <div className="integration-card">
                <div className="integration-flag">🇹🇿</div>
                <h3>Tanzania Revenue Authority</h3>
                <p>Complete VFD integration and tax compliance</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Automate Your Tax Compliance?</h2>
            <p>
              Join businesses across East Africa who trust Kodi Africa for their
              fiscal compliance needs
            </p>
            <div className="cta-actions">
              <a
                href="https://strutstechnology.co.ke/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary large"
              >
                Start Your Free Trial
              </a>
            </div>
          </div>
        </div>
      </section>

      <ModernFooter />
    </div>
  );
};

export default KodiAfrica;
